import styled from 'styled-components';

export const UserReviewPrompt = styled.div`
  display: inline-block;
  max-width: 270px;
  align-self: center;
`;

export const FirstToReview = styled.p``;
